module.exports = __webpack_public_path__ + "static/img/employ_fraud.3e2dc9d6.jpg";